// extracted by mini-css-extract-plugin
export var languageFlag = "LanguageItem-module--languageFlag--0bb53";
export var languageItem = "LanguageItem-module--languageItem--b313c";
export var languageItemAnimate = "LanguageItem-module--languageItemAnimate--725b0";
export var languageName = "LanguageItem-module--languageName--c59d8";